import { useState } from "react";
import "./LegalAccordion.css";

const LegalAccordion = ({ section }) => {

    const [open, setOpen] = useState(false);

    return (

        <div className="legal-item">

            <button
                className="legal-header"
                onClick={() => setOpen(!open)}
            >

                <span>{section.title}</span>

                <span className={`arrow ${open ? "open" : ""}`}>
                    ▼
                </span>

            </button>

            {open && (

                <div className="legal-content">

                    {section.content}

                </div>

            )}

        </div>

    );

};

export default LegalAccordion;